interface LoadingProps {
  message?: string;
}

export const Loading = ({ message }: LoadingProps) => {
  return (
    <>
      <div className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-[#1c489d] text-white text-xl flex-col gap-4">
        {message ? (
          <span>{message}</span>
        ) : (
          <span>
            よみこみ中
            <span className="animate-fade-in-long animation-delay-500 animation-infinite">.</span>
            <span className="animate-fade-in-long animation-delay-1000 animation-infinite">.</span>
            <span className="animate-fade-in-long animation-delay-1500 animation-infinite">.</span>
          </span>
        )}
      </div>
    </>
  );
};
